export const ApplyWrappedStyles = () => {
  const wrappedCssText = `
      .gift-block__launcher {
        padding-left: 16px !important;
        padding-right: 16px !important;
        border-radius: 1rem !important;
      }
      .gift-block__launcher:hover, 
      gift-dialog-actions button:hover {
        background-color: #006375 !important;
        color: #CFEBED !important;
      }
      .gift-block__launcher .label{
        font-size: 14px !important;
        line-height: 20px !important;
      }
      gift-dialog-header #close-button, 
      gift-dialog-header #close-button svg {
        color: #00b0be !important;
        background: transparent;
      }
      gift-dialog-header #close-button > span {
        font-size: 24px;
      }
      gift-dialog-content .gift-product-header,
      gift-dialog-actions:has(#remove-button:not([hidden]):not(.hidden):not([style*="display:none"])) > #save-button {
        display: none !important;
      }
      gift-dialog-actions button {
        border: 1px solid #00b0be !important;
        background: transparent !important;
      }
  `;

  setTimeout(() => {
    const elems = document.querySelectorAll("wrapped-gift-block");
    elems.forEach(elem => {
      if (!elem.shadowRoot) return;

      // 1. Prevent multiple style injections
      if (!elem.shadowRoot.querySelector('style[data-custom-style="wrapped-gift-block"]')) {
        const newStyle = document.createElement("style");
        newStyle.setAttribute("data-custom-style", "wrapped-gift-block");
        newStyle.textContent = wrappedCssText;
        elem.shadowRoot.appendChild(newStyle);
      }

      // 2. Query inside the shadowRoot to find the button label
      const saveButtonLabel = elem.shadowRoot.querySelector("gift-dialog-actions #save-button > .button-content > .label:not(.out-of-stock)");
      if (saveButtonLabel && saveButtonLabel.textContent !== "Add Gift Box to Order") {
        saveButtonLabel.textContent = "Add Gift Box to Order";
      }
    });
  }, 1500);
}
